import { render, staticRenderFns } from "./MeasuresList.vue?vue&type=template&id=45518af8&scoped=true"
import script from "./MeasuresList.vue?vue&type=script&lang=js"
export * from "./MeasuresList.vue?vue&type=script&lang=js"
import style0 from "./MeasuresList.vue?vue&type=style&index=0&id=45518af8&prod&lang=scss&scoped=true"
import style1 from "./MeasuresList.vue?vue&type=style&index=1&id=45518af8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45518af8",
  null
  
)

export default component.exports